<glxy-alert  type="tip">
 {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.COMPLETE_SETUP_V2' | translate }}
</glxy-alert>

<mat-stepper
  #stepper
  data-testid="meeting-scheduler-setup-wizard"
  class="schedule-stepper"
  labelPosition="bottom"
  [selectedIndex]="(wizardStep$ | async) || 0"
  (selectionChange)="onStepperSelectionChange($event)"
>
  <mat-step [label]="(stepLabels$ | async)?.step1 || 'Step 1'" [completed]="((wizardStep$ | async) || 0) >= 1">
    <meeting-scheduler-calendar-slug-card
      [calendarId]="personalCalendarId$ | async"
      [setInitial]="true"
      buttonLabel="{{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUTTONS.NEXT' | translate }}"
      (saveButtonClicked)="setStep(stepper.selectedIndex + 1)"
    ></meeting-scheduler-calendar-slug-card>
  </mat-step>

  <mat-step [label]="(stepLabels$ | async)?.step2 || 'Step 2'" [completed]="((wizardStep$ | async) || 0) >= 2">
    <mat-card>
      <mat-card-content>
        <meeting-scheduler-settings-calendar (calendarProviderSelected)="handleCalendarProvider($event)">
          <div align="end" class="action-bar">
            @if (selectedCalendarProvider === 'google') {
              <meeting-scheduler-connect-with-google-button
                [serviceKey]="SERVICE_KEYS.settingsPageCalendarConnected"
                [primaryDisconnect]="false"
              ></meeting-scheduler-connect-with-google-button>
            }
            @if (selectedCalendarProvider === 'microsoft') {
              <meeting-scheduler-connect-with-microsoft-button
                [serviceKey]="SERVICE_KEYS.settingsPageCalendarConnected"
                [primaryDisconnect]="false"
              ></meeting-scheduler-connect-with-microsoft-button>
            }

            @if ((isGoogleMeetConfigured && selectedCalendarProvider === 'google') || (isMicrosoftConfigured && selectedCalendarProvider === 'microsoft')) {
              <button
                [disabled]="disableStep2Next$ | async"
                mat-raised-button
                color="primary"
                type="submit"
                matStepperNext
                class="step-3-next-button"
              >
                {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUTTONS.NEXT' | translate }}
              </button>
            }
          </div>
        </meeting-scheduler-settings-calendar>
      </mat-card-content>
    </mat-card>
  </mat-step>

  <mat-step [label]="(stepLabels$ | async)?.step3 || 'Step 3'" [completed]="((wizardStep$ | async) || 0) >= 3">
    <mat-card>
      <mat-card-content>
        <meeting-scheduler-settings-meeting-app
          [serviceKey]="SERVICE_KEYS.settingsPageConferencingConnected"
          [hostPreferences]="hostPreferences"
          (integrationSelection)="onIntegrationSelection($event)"
        >
          <div class="step-2-actions">
            @if (integrationsPageLink$ | async; as integrationsPageLink) {
              <button
                 mat-stroked-button
                [routerLink]="[integrationsPageLink]"
                class="open-integration-settings-button"
              >
                Open integration settings
              </button>
            }
            <button
              [disabled]="!selectedIntegrationConnected"
              mat-raised-button
              color="primary"
              type="submit"
              matStepperNext
              class="step-3-next-button"
            >
              {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUTTONS.NEXT' | translate }}
            </button>
          </div>
        </meeting-scheduler-settings-meeting-app>
      </mat-card-content>
    </mat-card>
  </mat-step>

  <mat-step [label]="(stepLabels$ | async)?.step4 || 'Step 4'" [completed]="((wizardStep$ | async) || 0) === 4">
    <meeting-scheduler-settings-availability-card
      #availabilityCard
      [isHostConfigured]="isHostConfigured"
      [selectedCalendarProvider]="selectedCalendarProvider"
      [meetingAppSelection]="meetingAppSelection()"
      (availabilitySaved)="onAvailabilitySaved()"
    ></meeting-scheduler-settings-availability-card>
  </mat-step>
</mat-stepper>

@if (((wizardStep$ | async) || 0) === 3) {
  <glxy-sticky-footer [rightAligned]="true">
    @if (availabilityCard?.savingAvailabilityForm) {
      <span>
        <mat-spinner [diameter]="30" [strokeWidth]="8"></mat-spinner>
      </span>
    } @else {
      @if (isHostConfigured) {
        <button mat-raised-button color="primary" type="button" (click)="availabilityCard?.completeSetup()">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.SAVE' | translate }}
        </button>
      }
      @if (!isHostConfigured) {
        <button mat-raised-button color="primary" type="button" (click)="availabilityCard?.completeSetup()">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.COMPLETE_SETUP' | translate }}
        </button>
      }
    }
  </glxy-sticky-footer>
}
